/** `1234567` -> `"1.2 MB"`. One decimal place, always in MB regardless of magnitude -- the one unit this app's storage UI (downloads panel) needs, not a general adaptive-unit formatter. */
export function formatMegabytes(bytes: number): string {
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
